<template>
  <b-container fluid>
    <b-row align-h="center" align="center">

      <b-col cols="12" md="10" lg="7">
        <b-row no-gutters > 
          <b-col >
            <b-img src="@/assets/portadapagos.jpg"  fluid-grow alt="Fluid-grow image"></b-img>
          </b-col>
        </b-row>

        <b-row class="mt-5">
          <b-col cols="12">
            <h4>Da click para continuar con el pago.</h4>
          </b-col>
          <b-col class="mt-3">
            <div>
               <form id="formbbva" method="post" :action="urlAdqr">  
                <input class="form-submit-button" type="submit" value=" Realizar Pago ">  <br>
                <b class="input-multi"> idexpress: </b><input  class="input-multi" name="idexpress" v-model="formData.idexpress"><br> 
                <b class="input-multi"> referencia:</b><input class="input-multi" name="referencia" v-model="formData.referencia"><br>               
                <b class="input-multi"> importe:</b><input class="input-multi" name="importe" v-model="formData.importe"><br> 
                <b class="input-multi"> signature:</b><input class="input-multi" name="signature" v-model="formData.signature"><br> 
                <b class="input-multi"> urlretorno:</b><input class="input-multi" name="urlretorno" v-model="formData.urlretorno"><br> 
                <input type="hidden" name="financiamiento" value="0"/>
                <input type="hidden" name="plazos" value=""/>
                <input type="hidden" name="mediospago" value="1000000"/>                
              </form>
            </div>  
          </b-col>
        </b-row>
        
      </b-col>
    </b-row>

   
  </b-container>
</template>


<script>
import { mapState} from 'vuex';
import Vue from 'vue';
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue';
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)

export default {
  computed:{
    ...mapState({
      parcialidades: state => state.contribuyente.parcialidades,
      totalLiquidacion: state => state.contribuyente.totalLiquidacion,
      datosPago: state => state.contribuyente.datosPago,
      isCalculando: state => state.contribuyente.isCalculando,
      isGenerando: state => state.contribuyente.isGenerando,
      idxUltParcialidad: state => state.contribuyente.idxUltParcialidad,
      msgErrorContribuyente: state => state.contribuyente.msgErrorContribuyente,
      msgErrorGenLinea: state => state.contribuyente.msgErrorGenLinea,
      terminosServicio: state => state.contribuyente.catalogContribuyente.terminosServicio,
      thems: state => state.contribuyente.catalogContribuyente.thems,
      test: state => state.contribuyente.test
    }),
    urlAdqr: function(){
        var mpio = this.$route.params.municipio;
        return mpio.includes('demo')?"https://www.adquiramexico.com.mx:443/mExpress/pago/avanzado":"https://www.adquiramexico.com.mx:443/mExpress/pago/avanzado";
      },
    
  },
  data(){
    return{
      urlAction:"",
      formData:{
      }
    }
  },
  components: {
  },
  created: function () {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    this.formData = {
      "idexpress" : urlParams.get('idexpress'),
      "referencia" : urlParams.get('referencia'),
      "signature"  : urlParams.get('signature'),
      "importe"  : urlParams.get('importe'),
      "urlretorno" : urlParams.get('urlretorno'),
    } 

  },
  methods:{
    

  },
  validations:{
    
  }
}
</script>
<style>
  .input-multi{
    color: white;
    border: white;
    font-size : 1px;
  }
  .form-submit-button {
    font-size : 38px;
    padding: 5px;
    background: #28A745;
    color: #fff;
    border: 1px solid #eee;
    border-radius: 33px;
    box-shadow: 5px 5px 5px #eee;
    text-shadow: none;
  }
    .form-submit-button:hover {
    background: #75C592;
    color: #fff;
    border: 1px solid #eee;
    border-radius: 33px;
    box-shadow: 5px 5px 5px #eee;
    text-shadow: none;
  }
</style>